module.exports = {
      id: "spanish-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#spanish-usage",
      toString: function () {
        return this.url;
      }
    }